import React from "react";
import logo from "../../../Assets/logo.webp";
import "./style.css";
import { Button } from "../../../Components/Button/Button";
import { Link } from "react-router-dom";
import { Reveal } from "../../../Components/Reveal/Reveal";
import { Footer } from "../../../Components/Footer/Footer";
import logo1 from "../../../Assets/ads/download.png";
import logo2 from "../../../Assets/ads/erisLogo.png";
import logo3 from "../../../Assets/ads/ngclogo.png";
import logo4 from "../../../Assets/ads/zipLogo.png";
import ter from "../../../Assets/ter.png";

export const SoftwareDev = () => {
  return (
    <>
      <div className="ads-page-main">
        <div className="logo-box-container-ads content-sizing">
          <Link to="/">
            <img src={logo} width={160} />
          </Link>
        </div>

        <div className="content-sizing ads-header-section">
          <h1>
            <s>$5000</s> <span>Free Custom Software</span>
          </h1>
          <h2>Development Blueprint</h2>
        </div>

        <div className="content-sizing left-header-right-header-ads">
          <div className="left-header-ads">
            <p>
              Bring your innovative software idea to life risk-free! Your free
              custom software development blueprint includes the following:
            </p>
            <ul>
              <li>
                <i className="bi bi-check2"></i>Complete Feature Breakdown
              </li>
              <li>
                <i className="bi bi-check2"></i>Optimized Technical Stack
              </li>
              <li>
                <i className="bi bi-check2"></i>Strategic Development Approach
                To Avoid Blind Spots
              </li>
              <li>
                <i className="bi bi-check2"></i>Tentative Timeline To Go From
                Zero To Launch!
              </li>
              <li>
                <i className="bi bi-check2"></i>Guaranteed Security and
                Confidentiality for Your Concept
              </li>
              <li>
                <i className="bi bi-check2"></i>Zero Obligation - Opt Out
                Anytime
              </li>
              <li>
                <i className="bi bi-check2"></i>Our Team Consists of Experts in
                Every Industry
              </li>
            </ul>
            <h3>100+ startups, businesses, and agencies trust us</h3>

            <ul className="company-logos">
              <li>
                <img src={logo1} alt="company logo" />
              </li>
              <li>
                <img src={logo2} alt="company logo" />
              </li>
              <li>
                <img src={logo3} alt="company logo" />
              </li>
              <li>
                <img src={logo4} alt="company logo" />
              </li>
            </ul>
          </div>

          <form className="contact-form-main ads-header-contact-form">
            <div className="form-header-ads">
              <h2>Share your project details</h2>
              <p>
                if qualified, we'll build you a Free blueprint within 1-2 weeks
              </p>
            </div>
            <div className="col-1-input">
              <label htmlFor="email">Full Name *</label>
              <input
                id="email"
                placeholder="Your Email"
                type="email"
                name="email"
              />
            </div>

            <div className="col-1-input">
              <label htmlFor="email">Email *</label>
              <input
                id="email"
                placeholder="Your Email"
                type="email"
                name="email"
              />
            </div>

            <div className="col-1-input">
              <label htmlFor="message">
                What services are you interested in? *
              </label>
              <textarea
                id="message"
                placeholder="Leave us a message..."
                name="message"
              />
            </div>

            <Button>Get your Free Blueprint</Button>
          </form>
        </div>

        <div className="our-promises content-sizing">
          <h2>Our Promise</h2>

          <ul>
            <li>
              <div className="bg-primary-red-light text-primary-red-default">
                <i className="bi bi-escape"></i>
              </div>
              <h2>Discovery</h2>
              <p>
                We start with a thorough discovery phase, conducting market
                analysis and competitor research to understand your unique needs
                and goals.
              </p>
            </li>
            <li>
              <div className="text-primary-blue-default bg-primary-blue-light">
                <i class="bi bi-speedometer2"></i>
              </div>
              <h2>UI/UX Design</h2>
              <p>
                Our designs align seamlessly with your strategy, ensuring
                user-friendliness and prominence. Simple and intuitive design
                captures your audience&#39;s attention.
              </p>
            </li>
            <li>
              <div className="bg-primary-green-light text-primary-green-default">
                <i class="bi bi-tools"></i>
              </div>
              <h2>Software Development</h2>
              <p>
                We build robust solutions using agile methodology, iterating
                based on user feedback. The right tech stack and development
                techniques minimize errors.
              </p>
            </li>
            <li>
              <div className="bg-primary-orange-light text-primary-orange-default">
                <i class="bi bi-water"></i>
              </div>
              <h2>Testing</h2>
              <p>
                Before launch, as a meticulous software development agency, we
                prioritize conducting in-depth market research and gathering
                user insights to refine your product.
              </p>
            </li>
            <li>
              <div className="bg-primary-purple-light text-primary-purple-default ">
                <i class="bi bi-shield-check"></i>
              </div>
              <h2>Delivery</h2>
              <p>
                We release the initial product version, ensuring quality and
                stability. Preparations are made for real-world testing by early
                adopters.
              </p>
            </li>
            <li>
              <div className="bg-primary-red-light text-primary-red-default">
                <i class="bi bi-headset"></i>
              </div>
              <h2>Support</h2>
              <p>
                Our dedicated team ensures your software runs smoothly with
                comprehensive maintenance, regular updates, and prompt issue
                resolution.
              </p>
            </li>
          </ul>
        </div>

        <div className="testimonal content-sizing">
          <h2>
            " I was pleased with{" "}
            <span>DataDept's Team quality, consistency and execution.</span> "
          </h2>

          <h3>Dr.J. Ayo Akinyele</h3>
          <p>President, Co-Founder, Yeletech</p>

          <ul className="test-list">
            <li>
              <i className="bi bi-clock-history"></i>
              <div>
                <h3>16 Weeks</h3>
                <p>from idea to launch</p>
              </div>
            </li>
            <li>
              <i className="bi bi-percent"></i>
              <div>
                <h3>25% boots</h3>
                <p>in brand sales</p>
              </div>
            </li>
          </ul>

          <img src={ter} />
        </div>

        {/* <div className='our-promises content-sizing'>
        <h2>The tech stack that drives our custom software development services.</h2>

        <ul>
          <li>
            <div className='bg-primary-red-light text-primary-red-default'>
              <i className="bi bi-escape"></i>
            </div>
            <h2>React</h2>
          </li>
          <li>
            <div className='bg-primary-red-light text-primary-red-default'>
              <i className="bi bi-escape"></i>
            </div>
            <h2>Nextjs</h2>
          </li>
          <li>
            <div className='bg-primary-red-light text-primary-red-default'>
              <i className="bi bi-escape"></i>
            </div>
            <h2>AWS</h2>
          </li>
          <li>
            <div className='bg-primary-red-light text-primary-red-default'>
              <i className="bi bi-escape"></i>
            </div>
            <h2>Discovery</h2>
          </li>
          <li>
            <div className='bg-primary-red-light text-primary-red-default'>
              <i className="bi bi-escape"></i>
            </div>
            <h2>Redux</h2>
          </li>
        </ul>
      </div> */}

        <section className="about-page-section-2 container-style">
          <div className="content-sizing about-page-section-2-wrapper">
            <div className="about-box-company-header">
              <div className="header-left-about-2">
                <span className="small-tag">FAQ SECTION</span>
                <h2>Frequently asked questions</h2>
              </div>
            </div>

            <ul className="faq-list-item">
              <Reveal delay={0.1}>
                <li className="single-question-faq">
                  <div className="icon-container-faq">
                    <i className="bi bi-code-square"></i>
                  </div>
                  <div className="faq-content-item-box">
                    <h3>What Is Custom Software Development?</h3>
                    <p>
                      Custom software development involves crafting tailored
                      solutions for specific user needs, offering more efficient
                      and effective results than off-the-shelf options.
                    </p>
                  </div>
                </li>
              </Reveal>
              <Reveal delay={0.15}>
                <li className="single-question-faq">
                  <div className="icon-container-faq">
                    <i className="bi bi-journal-code"></i>
                  </div>
                  <div className="faq-content-item-box">
                    <h3>
                      What Distinguishes SaaS Development from Traditional
                      Software?
                    </h3>
                    <p>
                      SaaS product development creates scalable, cloud-based
                      applications with subscription-based billing, contrasting
                      with traditional on-premises software creation.
                    </p>
                  </div>
                </li>
              </Reveal>
              <Reveal delay={0.2}>
                <li className="single-question-faq">
                  <div className="icon-container-faq">
                    <i className="bi bi-cloud-check"></i>
                  </div>
                  <div className="faq-content-item-box">
                    <h3>What Benefits Do Cloud Solutions Offer Businesses?</h3>
                    <p>
                      Cloud solutions enhance business efficiency, scalability,
                      and accessibility, reducing IT costs and allowing
                      operations to adjust swiftly to demand.
                    </p>
                  </div>
                </li>
              </Reveal>

              <Reveal delay={0.3}>
                <li className="single-question-faq">
                  <div className="icon-container-faq">
                    <i className="bi bi-shield-lock"></i>
                  </div>
                  <div className="faq-content-item-box">
                    <h3>How to Future-Proof Your Software Solution?</h3>
                    <p>
                      Future-proofing your software requires using flexible
                      technologies, adhering to best practices, and updating
                      regularly to stay ahead of trends.
                    </p>
                  </div>
                </li>
              </Reveal>

              <Reveal delay={0.3}>
                <li className="single-question-faq">
                  <div className="icon-container-faq">
                    <i className="bi bi-check2-circle"></i>
                  </div>
                  <div className="faq-content-item-box">
                    <h3>How Does DataDept Guarantee Software Quality?</h3>
                    <p>
                      DataDept guarantees software excellence with thorough
                      testing, continuous practices, and strict industry
                      standards, ensuring robust, secure, and efficient
                      solutions.
                    </p>
                  </div>
                </li>
              </Reveal>

              <Reveal delay={0.3}>
                <li className="single-question-faq">
                  <div className="icon-container-faq">
                    <i className="bi bi-cloud-upload"></i>
                  </div>
                  <div className="faq-content-item-box">
                    <h3>
                      Can DataDept help migrate my existing application to the
                      cloud?
                    </h3>
                    <p>
                      Yes, DataDept specializes in helping businesses migrate
                      their existing applications to the cloud. Our
                      comprehensive cloud migration services include assessing
                      your current infrastructure, planning the migration,
                      executing the move with minimal downtime, and optimizing
                      your new cloud environment for performance and cost.
                    </p>
                  </div>
                </li>
              </Reveal>
            </ul>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};
